import React from 'react';

import { StyledWrapper, StyledTitle } from './logo.style';

const Logo = () => (
  <StyledWrapper to="/">
    <StyledTitle>
      MYJNIA<span>KOŁO</span>
    </StyledTitle>
  </StyledWrapper>
);

export default Logo;


// WEBPACK FOOTER //
// ./src/components/logo/logo.component.js